import React from 'react';
import styled from '@emotion/styled';
import AppleAppStoreLogo from '../../../assets/svg/AppleAppStoreLogo';
import HandOffLink from '../../../utils/urls/HandOffLink';
import SocialIcons from './SocialIcons';
import colors from '../../../styling/colors';
import { breakpoints } from '../../../styling/themes/FlexboxGridThemes';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

const AppleAppStoreLogoWrapper = styled.div`
  width: 100px;
  height: 33px;

  @media (${DESKTOP_START_QUERY}) {
    width: 120px;
    height: 40px;
  }
`;

const Column = styled.div`
  flex-basis: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (${DESKTOP_START_QUERY}) {
    flex-basis: 100%;
    justify-content: left;
  }
`;

const ColumnLast = styled(Column)`
  @media (${DESKTOP_START_QUERY}) {
    height: calc(100% - 16px);
    align-items: flex-end;
  }
`;

const IconLinks = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 1.5rem 0 1rem;
  padding: 1rem 0;
  border-style: solid;
  border-color: ${colors('gallery')};
  border-width: 1px 0;

  @media (${DESKTOP_START_QUERY}) {
    border: 0;
    margin: 0;
    padding: 0;
  }
`;

export default () => (
  <IconLinks>
    <Column>
      <SocialIcons />
    </Column>
    <ColumnLast>
      <AppleAppStoreLogoWrapper>
        <HandOffLink
          identifier="paperless-post-app-download"
          href="https://paperlesspost.app.link/website_footer"
        >
          <AppleAppStoreLogo />
        </HandOffLink>
      </AppleAppStoreLogoWrapper>
    </ColumnLast>
  </IconLinks>
);
